import { browserTracingIntegration, init } from '@sentry/react'

const dsn = import.meta.env.VITE_SENTRY_DSN ?? undefined

if (dsn) {
  init({
    dsn,
    integrations: [browserTracingIntegration()],
    tracesSampleRate: 1.0,
  })
}
